import { SET_AADD_BENF_LIST_PAGE, SET_ANM_ID_SELECTED, SET_ARRIVAL_STATUS, SET_BENF_DUE_LIST_PAGE_TYPE, SET_GO_TO_SERVICES, SET_MAIN_PAGE_TOOGLE, SET_REMOVAL_REASON_DATA, SET_SESSION_DETAIL_DATA, SET_SESSION_ID, SET_SHOW_DUE_LIST, SET_SHOW_DUE_LIST_FROM_MAIN_PAGE, SET_SHOW_UPCOMING_SESSION_DETAILS_BY_ID, SET_VHND_EXECUTION_STATUS, eventExecutionType } from "@store/types/eventExecutionTypes";

export interface EventExecutionState {
    upcomingSessionDetailsById: any;
    showDueList: any;
    showDueListFromMainPage: any;
    vhndExecutionStatusData: any;
    benfArrivalStatusData: any;
    removalReasonData: any;
    sessionDetailData: any;
    toogleSelected: any;
    selectedUpcomingSessionId: any;
    listPageType: any;
    showAddBenefComponent: any;
    goToServices: any;
    selectedAnmIdByMoic: any;
};

const eventExecutionReducer = (
    state = {
        upcomingSessionDetailsById: false,
        showDueList: false,
        showDueListFromMainPage: false,
        vhndExecutionStatusData: null,
        benfArrivalStatusData: null,
        removalReasonData: null,
        sessionDetailData: null,
        toogleSelected: 'today',
        selectedUpcomingSessionId: '',
        listPageType: 'dueList',
        showAddBenefComponent: false,
        goToServices: {
            isFromVhnd: false,
            benfId: null
        },
        selectedAnmIdByMoic: null
    },
    action: eventExecutionType,
): EventExecutionState => {
    switch (action.type) {
        case SET_SHOW_UPCOMING_SESSION_DETAILS_BY_ID:
            return { ...state, upcomingSessionDetailsById: action.payload };

        case SET_SHOW_DUE_LIST:
            return { ...state, showDueList: action.payload };

        case SET_SHOW_DUE_LIST_FROM_MAIN_PAGE:
            return { ...state, showDueListFromMainPage: action.payload };

        case SET_VHND_EXECUTION_STATUS:
            return { ...state, vhndExecutionStatusData: action.payload };

        case SET_ARRIVAL_STATUS:
            return { ...state, benfArrivalStatusData: action.payload };

        case SET_REMOVAL_REASON_DATA:
            return { ...state, removalReasonData: action.payload };

        case SET_SESSION_DETAIL_DATA:
            return { ...state, sessionDetailData: action.payload };

        case SET_MAIN_PAGE_TOOGLE:
            return { ...state, toogleSelected: action.payload };

        case SET_SESSION_ID:
            return { ...state, selectedUpcomingSessionId: action.payload };

        case SET_BENF_DUE_LIST_PAGE_TYPE:
            return { ...state, listPageType: action.payload };

        case SET_AADD_BENF_LIST_PAGE:
            return { ...state, showAddBenefComponent: action.payload };

        case SET_GO_TO_SERVICES:
            return { ...state, goToServices: action.payload };

        case SET_ANM_ID_SELECTED:
            return { ...state, selectedAnmIdByMoic: action.payload };

        default:
            return state;
    }
};

export default eventExecutionReducer;